import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

import { Partitioning } from '@classes/partitioning';
import { Partition } from '@classes/simulation/partition';
import { OriginCategory } from '@classes/origin/origin-category';

interface PartitionsWithType {
    amountTypes: OriginCategory[];
    partitions: Partition[];
}

@Injectable({
    providedIn: 'root'
})
export class PartitioningService {
    private baseUrl = environment.apiUrl + 'partitionings';

    constructor(
        private http: HttpClient
    ) { }

    getList(): Observable<Partitioning[]> {
        return this.http.get<Partitioning[]>(this.baseUrl);
    }

    getPartitions(partitioningCode?: string): Observable<PartitionsWithType> {
        let url = this.baseUrl;

        if(partitioningCode) {
            url += '/' + partitioningCode;
        }

        url += '/partitions';

        return this.http.get<PartitionsWithType>(url);
    }
}
